import React from 'react';
import './input.css';
import { Tooltip } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

const CustomInputSelect = ({
  label,
  name,
  value,
  onChange,
  error,
  disabled,
  options,
  hidden,
}) => {
  const inputStyle = {
    borderColor: error ? '#F56565' : '', // Set border color to red if there is an error
  };
  return (
    <div
      className="container-input"
      style={{ display: disabled ? 'none' : '' }}
    >
      <label className="py-1">
        <b>{label}</b>
        <select
          className="form-select custom-input"
          disabled={disabled}
          name={name}
          value={value}
          onChange={onChange}
          style={inputStyle}
        >
          {options.map((option, index) => (
            <option
              key={`${label}-${index}`}
              value={option.value}
            >
              {option.text}
            </option>
          ))}
        </select>
      </label>
      {error && (
        <Tooltip
          label={error}
          aria-label="A tooltip"
        >
          <div className="d-flex flex-row align-items-center">
            <span className="single-line">
              <InfoIcon /> {error}
            </span>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default CustomInputSelect;
